(function (angular) {
  angular.module('acme.common.service.tenantApi', []).service('TenantApiService', TenantApiService);

  TenantApiService.$inject = ['$http'];

  function TenantApiService($http) {
    return {
      service: '',

      init: function (endpoint) {
        this.service = endpoint + '/tenant';
        this.calendar.service = this.service + '/calendar';
        this.reasons.service = this.service + '/settings/refund/reasons';
        this.config.service = endpoint + '/tenantproductconfig';
        return this;
      },
      view: function () {
        return $http({
          method: 'get',
          url: this.service,
        });
      },

      isIntegrationEnabled: function () {
        data = this.view();
        return data.sf_sync;
      },

      update: function (props) {
        return $http({
          method: 'put',
          url: this.service + '/' + props.id,
          data: {
            firstName: props.firstName,
            lastName: props.lastName,
            streetAddress1: props.streetAddress1,
            streetAddress2: props.streetAddress2,
            city: props.city,
            state: props.state,
            country: props.country,
            zipCode: props.zipCode,
            name: props.name,
            phoneNumber: props.phoneNumber,
            companyUrl: props.companyUrl,
            timezone: props.timezone,
            logoImage: props.logoImage,
          },
        });
      },

      activate: function (props) {
        return $http({
          method: 'post',
          url: this.service + '/' + props.id + '/activate',
          data: {
            firstName: props.firstName,
            lastName: props.lastName,
            streetAddress1: props.streetAddress1,
            streetAddress2: props.streetAddress2,
            city: props.city,
            state: props.state,
            country: props.country,
            zipCode: props.zipCode,
            name: props.name,
            phoneNumber: props.phoneNumber,
            companyUrl: props.companyUrl,
            timezone: props.timezone,
            logoImage: props.logoImage,
          },
        });
      },

      create: function (props) {
        return $http({
          method: 'post',
          url: this.service + '/',
          data: {
            orgName: props.orgName,
            email: props.email,
          },
        });
      },

      reasons: {
        service: '',

        list: function () {
          return $http({
            method: 'get',
            url: this.service,
          });
        },
      },

      calendar: {
        service: '',

        detail: function () {
          return $http({
            method: 'get',
            url: this.service,
          });
        },

        create: function (props) {
          return $http({
            method: 'post',
            url: this.service,
            data: {
              standard: props.standard,
              exceptions: props.exceptions,
            },
          });
        },

        update: function (props) {
          return $http({
            method: 'put',
            url: this.service,
            data: {
              id: props.id,
              standard: props.standard,
              exceptions: props.exceptions,
            },
          });
        },
      },

      config: {
        service: '',

        list: function () {
          return $http({
            method: 'get',
            url: this.service.replace(/v1/, 'v2') + '/list',
          });
        },
      },
    };
  }
})(window.angular);
